module.exports = __webpack_public_path__ + "img/decision.a2e1fe5.svg";